export type LocationLabelParts = {
  place?: string;
  region?: string;
  country?: string;
};

export default function formatLocationLabel({
  place,
  region,
  country,
}: LocationLabelParts): string {
  return [place, region, country].filter(Boolean).join(', ');
}
